import classnames from 'classnames';

import styles from './index.module.css';

export enum Size {
  Small = 'SmallPadding',
  SmallHorizontalPadding = 'SmallHorizontalPadding',
  Medium = 'MediumPadding',
  Large = 'LargePadding',
}

export enum Width {
  Default = 'DefaultWidth',
  Full = 'FullWidth',
  ContentWidth = 'ContentWidth',
}

export enum Margin {
  Default = 'DefaultMargin',
  None = 'NoMargin',
  Submit = 'SubmitMargin',
  Enum = 'EnumMargin',
  Modal = 'ModalMargin',
}

type Variant = 'primary' | 'secondary';

export interface Props extends React.PropsWithChildren {
  invertColors?: boolean;
  size?: Size;
  fontSize?: string;
  width?: Width;
  margin?: Margin;
  variant?: Variant;

  // Pass-through props
  id?: string;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  tabIndex?: number;
  buttonRef?: React.RefObject<HTMLButtonElement>;
}

export const Button: React.FC<Props> = (props) => {
  const {
    className,
    size,
    fontSize,
    width,
    invertColors,
    margin,
    buttonRef,
    variant = 'primary',
    ...buttonProps
  } = props;
  const classNames = [
    className,
    styles.Button,
    styles[size || Size.Medium],
    styles[width || Width.Full],
    styles[margin || Margin.Default],
  ]
    .filter(Boolean)
    .join(' ');

  const style: React.CSSProperties = {};
  if (fontSize) style.fontSize = fontSize;

  return (
    <button
      className={classnames(classNames, {
        [styles.Secondary]: variant === 'secondary',
        [styles.Inverted]: invertColors,
      })}
      style={style}
      ref={buttonRef}
      {...buttonProps}
    />
  );
};
